var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightdashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7999 14.8181C16.0355 14.7052 16.2502 14.553 16.4347 14.3681C17.3333 13.4703 17.3333 12.0244 17.3333 9.1333C17.3333 6.24222 17.3333 4.79629 16.4347 3.89853C15.5362 3.00077 14.091 3 11.2 3H8.1333C5.24222 3 3.79629 3 2.89853 3.89853C2.00077 4.79706 2 6.24222 2 9.1333C2 12.0244 2 13.4703 2.89853 14.3681C3.08406 14.5544 3.29259 14.7016 3.53333 14.8181",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09498 13.0049C8.80798 12.2919 9.16524 11.9347 9.60531 11.9109C9.64619 11.9094 9.68683 11.9094 9.72721 11.9109C10.1673 11.9339 10.5245 12.2912 11.2383 13.0049C12.7916 14.5582 13.5682 15.3348 13.3505 16.0049C13.3319 16.0623 13.3088 16.1182 13.2815 16.172C12.961 16.7999 11.8631 16.7999 9.66664 16.7999C7.47015 16.7999 6.37152 16.7999 6.05182 16.172C6.02447 16.1182 6.0014 16.0623 5.98283 16.0049C5.76509 15.3348 6.54172 14.5582 8.09498 13.0049Z",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightdashboardIcon);
export default __webpack_public_path__ + "static/media/light.dashboard-icon.3c8200d10a69caaaa6b82f10ee01486e.svg";
export { ForwardRef as ReactComponent };